import React, { useState } from 'react';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { ConfirmDeleteModal } from 'components/common/ConfirmDeleteModal/ConfirmDeleteModal';

import { useReportsTemplatesLogic } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.logic';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.module.scss';
import { useReportTemplates } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.provider';
import { getTemplateById } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.utils';
import { CreateReportFromTemplateModal } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal';
import { EditReportTemplateModal } from 'components/widgets/ReportsHome/ReportsTemplates/components/EditReportTemplateModal/ReportTemplateEditModal';
import { TemplateCard } from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplateCard/TemplateCard';
import { TemplatesFilters } from 'components/widgets/ReportsHome/ReportsTemplates/components/TemplatesFilters/TemplatesFilters';

type Action = 'delete' | 'edit' | 'createReport';
export interface SelectedTemplateWithAction {
    templateId: number;
    action: Action;
}

export const ReportsTemplates = () => {
    const { handleSnackBar } = useCustomSnackBar();
    const { api } = useReportTemplates();
    const { logic } = useReportsTemplatesLogic({ api });
    const [selectedTemplate, setSelectedTemplate] = useState<SelectedTemplateWithAction | null>(null);

    const closeModal = () => setSelectedTemplate(null);

    return (
        <>
            <div className={classes.templatesWrapper}>
                <TemplatesFilters logic={logic} />
                <div className={classes.templatesCards}>
                    {logic.templateList.map((template) => {
                        return (
                            <TemplateCard
                                key={template.id}
                                template={template}
                                setTemplateForAction={setSelectedTemplate}
                            />
                        );
                    })}
                </div>
            </div>
            <CreateReportFromTemplateModal
                template={
                    selectedTemplate && selectedTemplate.action === 'createReport'
                        ? getTemplateById(selectedTemplate.templateId, logic.templateList)
                        : null
                }
                isShowModal={selectedTemplate !== null && selectedTemplate.action === 'createReport'}
                closeModal={closeModal}
            />

            <ConfirmDeleteModal
                open={selectedTemplate !== null && selectedTemplate.action === 'delete'}
                onClose={() => setSelectedTemplate(null)}
                action={async () => {
                    try {
                        if (selectedTemplate !== null) {
                            await logic.deleteTemplateCard(selectedTemplate.templateId);
                            setSelectedTemplate(null);
                        }
                    } catch (error) {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    }
                }}
                isLoading={api.deleteReportTemplate.instance.isLoading}
                title={'Delete Report Template'}
            >
                {`Do you want to delete '${selectedTemplate ? (getTemplateById(selectedTemplate?.templateId, logic.templateList)?.name ?? '') : ''}' Template?`}
            </ConfirmDeleteModal>
            <EditReportTemplateModal
                template={
                    selectedTemplate && selectedTemplate.action === 'edit'
                        ? getTemplateById(selectedTemplate.templateId, logic.templateList)
                        : null
                }
                closeModal={closeModal}
                isShowModal={selectedTemplate !== null && selectedTemplate.action === 'edit'}
            />
        </>
    );
};
